import { Loader2 } from "lucide-react";

export function LoadingCard({ msg = "Lade..." }: { msg?: string }) {
  return (
    <div className="absolute inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center rounded-lg border">
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">{msg}</p>
      </div>
    </div>
  );
}
